module.exports = __webpack_public_path__ + "img/banner.8e96fc0e.jpg";